import { configureStore } from "@reduxjs/toolkit";
// import { setAutoFreeze } from "immer";

// Reducers
import formDataReducer from "./formData";
import formValidityReducer from "./formValidity";
import bundleDataReducer from "./bundleData";

// setAutoFreeze(false);

const store = configureStore({
  reducer: {
    formData: formDataReducer,
    formValidity: formValidityReducer,
    bundleData: bundleDataReducer,
  },
});

export default store;
